import React from 'react';
import { useTranslation } from 'react-i18next';
import { usePopup } from '../../contexts/PopupContext';
import { BadgeList } from '../badges';
import { ProfileAchievementsCalendarLinkIcon } from './ProfileActivityIcons';

/**
 * Widżet: odznaki + link do pełnej listy w popupie.
 */
function ProfileAchievementsWidget({ stats, userRole }) {
  const { t } = useTranslation(['profile']);
  const { openPopup } = usePopup();

  const handleAchievementsOpen = () => {
    openPopup('achievements', { userRole, stats });
  };

  return (
    <section className="profile-achievements-widget" aria-labelledby="p-ach-widget-heading">
      <div className="profile-dash-widget-card">
        <header className="profile-dash-widget-head">
          <h2 id="p-ach-widget-heading" className="profile-dash-widget-title">
            {t('profile.dashboard.badgesTitle', 'Odznaki i postępy')}
          </h2>
          <button
            type="button"
            className="profile-dash-header-action"
            onClick={handleAchievementsOpen}
            title={t('achievementsPopup.title')}
          >
            <span className="profile-dash-header-action-icon" aria-hidden>
              <ProfileAchievementsCalendarLinkIcon
                size={17}
                className="p-dash-stat-icon-svg"
              />
            </span>
            <span className="profile-dash-header-action-label">
              {t('profile.dashboard.achievementsLink', 'Zobacz odznaki i osiągnięcia')}
            </span>
          </button>
        </header>

        <div className="profile-achievements-widget-body">
          <BadgeList
            userRole={userRole}
            stats={stats}
            showRoleBadge
            showActivityBadges
            size="medium"
          />
        </div>
      </div>
    </section>
  );
}

export default ProfileAchievementsWidget;
